import { type Compare, listUtils } from '@festina-life/core'

import type { ComparableField } from '../../types/diffing'
import {
  isConfigurationFunction,
  isSubTemplatedField,
  isSubTemplatedFieldValue,
  isTemplateField,
  isTemplateVersion,
  type SubTemplateFieldValue,
  ValueSetupRole,
} from '../../types/templateModel'
import { SpecialCasedSubTemplatedFieldValueDiff } from '../specialCasedSubTemplatedViewers/SpecialCasedSubTemplatedFieldValueDiff'
import { isSpecialCasedSubTemplatedValueSetup } from '../specialCasedSubTemplatedViewers/types'
import { ConfigurationTemplateFunctionValueDiff } from './ConfigurationTemplateFunctionValueDiff'
import { SubTemplatedFieldValueDiff } from './SubTemplatedFieldValueDiff'
import { SubTemplateFieldValueDiffContents } from './SubTemplateFieldValueDiffContents'
import { TemplateFieldDiff } from './TemplateFieldDiff'
import { TemplateVersionDiff } from './TemplateVersionDiff'

export const ValueSetupComparisonDiff = (props: Compare<ComparableField>) => {
  if (listUtils.isCompare(props, isSpecialCasedSubTemplatedValueSetup)) {
    return <SpecialCasedSubTemplatedFieldValueDiff {...props} />
  } else if (listUtils.isCompare(props, isSubTemplatedFieldValue)) {
    return <SubTemplatedFieldValueDiff {...props} />
  } else if (listUtils.isCompare(props, isTemplateField)) {
    if (
      listUtils.isCompare(props, isSubTemplatedField) &&
      props.current &&
      props.current.role === ValueSetupRole.SINGLE_CLASS_SUB_TEMPLATE
    ) {
      const comparableSubTemplatedFieldValue = {
        current: props.current.value?.variants.at(0),
        compare: props.compare?.value?.variants.at(0),
      } as Compare<SubTemplateFieldValue>

      return (
        <TemplateFieldDiff {...props}>
          <SubTemplateFieldValueDiffContents
            {...comparableSubTemplatedFieldValue}
          />
        </TemplateFieldDiff>
      )
    } else {
      return <TemplateFieldDiff {...props} />
    }
  } else if (listUtils.isCompare(props, isConfigurationFunction)) {
    return <ConfigurationTemplateFunctionValueDiff {...props} />
  } else if (listUtils.isCompare(props, isTemplateVersion)) {
    return <TemplateVersionDiff {...props} />
  } else {
    throw new Error('Unsupported field type used in the value setup comparison')
  }
}
